module.exports = __webpack_public_path__ + "img/guanyu_08.4848669a.png";